export { default as Routes } from './Routes';
